var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDracula(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 80,
    height: 80,
    rx: 8,
    fill: "#27292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 46.9091V38.1818C104 36.9818 103.018 36 101.818 36H93.0909C91.8909 36 90.9091 36.9818 90.9091 38.1818V40.3636H69.0909V38.1818C69.0909 36.9818 68.1091 36 66.9091 36H58.1818C56.9818 36 56 36.9818 56 38.1818V46.9091C56 48.1091 56.9818 49.0909 58.1818 49.0909H60.3636V70.9091H58.1818C56.9818 70.9091 56 71.8909 56 73.0909V81.8182C56 83.0182 56.9818 84 58.1818 84H66.9091C68.1091 84 69.0909 83.0182 69.0909 81.8182V79.6364H90.9091V81.8182C90.9091 83.0182 91.8909 84 93.0909 84H101.818C103.018 84 104 83.0182 104 81.8182V73.0909C104 71.8909 103.018 70.9091 101.818 70.9091H99.6364V49.0909H101.818C103.018 49.0909 104 48.1091 104 46.9091ZM60.3636 40.3636H64.7273V44.7273H60.3636V40.3636ZM64.7273 79.6364H60.3636V75.2727H64.7273V79.6364ZM90.9091 75.2727H69.0909V73.0909C69.0909 71.8909 68.1091 70.9091 66.9091 70.9091H64.7273V49.0909H66.9091C68.1091 49.0909 69.0909 48.1091 69.0909 46.9091V44.7273H90.9091V46.9091C90.9091 48.1091 91.8909 49.0909 93.0909 49.0909H95.2727V70.9091H93.0909C91.8909 70.9091 90.9091 71.8909 90.9091 73.0909V75.2727ZM99.6364 79.6364H95.2727V75.2727H99.6364V79.6364ZM95.2727 44.7273V40.3636H99.6364V44.7273H95.2727ZM82.0509 50.5091C81.7236 49.6582 80.8945 49.0909 79.9782 49.0909C79.0618 49.0909 78.2327 49.6582 77.9273 50.5091L71.8836 66.5018C71.4691 67.5709 72.2545 68.7273 73.4109 68.7273C74.1091 68.7273 74.72 68.2909 74.96 67.6364L76.16 64.3636H83.7745L84.9964 67.6582C85.2364 68.2909 85.8473 68.7273 86.5455 68.7273H86.5673C87.7236 68.7273 88.5091 67.5709 88.1164 66.5018L82.0509 50.5091ZM77.1418 61.6145L80 53.2582L82.8364 61.6145H77.1418Z",
    fill: "#9AA8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 160,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2775 0 0 0 0 0.225 0 0 0 0 0.6 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDracula);
export default __webpack_public_path__ + "static/media/Dracula.597b92cc52cec017908f335a77cc16b9.svg";
export { ForwardRef as ReactComponent };